export default "__VITE_ASSET__ZT0_z6to__"